import { render, staticRenderFns } from "./publicTrends.vue?vue&type=template&id=5bfd64c1&scoped=true&"
import script from "./publicTrends.vue?vue&type=script&lang=js&"
export * from "./publicTrends.vue?vue&type=script&lang=js&"
import style0 from "./publicTrends.vue?vue&type=style&index=0&id=5bfd64c1&prod&scoped=true&lang=less&"
import style1 from "./publicTrends.vue?vue&type=style&index=1&id=5bfd64c1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfd64c1",
  null
  
)

export default component.exports